"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAttributeValue = exports.formatAttributeName = void 0;
const i18n_1 = require("@app/util/i18n");
const _1 = require(".");
const format_hours_1 = require("./format-hours");
const moment_1 = __importDefault(require("moment"));
function formatAttributeName({ attribute, }) {
    let name = '-';
    if (!attribute)
        return name;
    if (attribute.name && attribute.shortName) {
        name = attribute.shortName + ' - ' + attribute.name;
    }
    else if (attribute.name) {
        name = attribute.name;
    }
    else if (attribute.shortName) {
        name = attribute.shortName;
    }
    return name;
}
exports.formatAttributeName = formatAttributeName;
function formatAttributeValue({ attribute, }) {
    if (!attribute)
        return '-';
    if (attribute.type === 'boolean' && attribute.value === true)
        return (0, i18n_1.t)('YES');
    if (attribute.type === 'boolean' && attribute.value === false)
        return (0, i18n_1.t)('NO');
    if (attribute.type === 'number')
        return _1.numberUtil.round2decimals(attribute.value);
    if (attribute.type === 'duration')
        return (0, format_hours_1.formatHours)(attribute.value / 60);
    if (attribute.type === 'date')
        return (0, moment_1.default)(attribute.value).format('D.M.YYYY');
    if (attribute.type === 'multiselect')
        return attribute.value.join(', ');
    return attribute.value;
}
exports.formatAttributeValue = formatAttributeValue;
